import { render, staticRenderFns } from "./quick.vue?vue&type=template&id=033e8c24&scoped=true&"
import script from "./quick.vue?vue&type=script&lang=js&"
export * from "./quick.vue?vue&type=script&lang=js&"
import style0 from "./quick.vue?vue&type=style&index=0&id=033e8c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e8c24",
  null
  
)

export default component.exports